export interface IDashboardPieItem {
  color: string;
  percent: number;
  title: string;
}

export enum DASHBOARD_COLOR {
  BLUE_EXTRA_LIGHT = '#D5EEFF',
  BLUE_LIGHT = '#A9DCFF',
  BLUE = '#37AEFF',
  BLUE_DARK = '#01579b',
  RED = '#E32620',
  RED_DARK = '#A61B1B',
  RED_EXTRA_LIGHT = '#ffeded',
  YELLOW_EXTRA_LIGHT = '#FFF0D6',
  YELLOW = '#FDA20A',
  GREEN_EXTRA_LIGHT = '#E3FFD9',
  GREEN_LIGHT = '#ABEB6D',
  GREEN = '#65BE46',
  GREEN_DARK = '#3D8624',
  DEFAULT = '#E3E3E3',
  BLACK = '#130921',
  ORANGE = '#FFBB32',
  ORANGE_DARK = '#ef6c00',
  ORANGE_EXTRA_LIGHT = '#FFF6D6',
  ORANGE_LIGHT = '#FFDE83',
}
